export default __webpack_public_path__ + "static/media/hinh1.3999ac41.jpeg";